import { Stack, Text } from '@chakra-ui/react'
import { faBan } from '@fortawesome/pro-regular-svg-icons'

import shouldShowSuspensionNote from '@/client/services/moderation/shouldShowSuspensionNote'
import * as url from '@/client/services/url'
import {
  SUSPENSION_ACTION_CONTEXT_TO_EXPLANATION,
  type SuspensionAction,
} from '@/client/services/user'

import ShwLink from '@/components/ShwLink'
import RichText from '@/components/UI/RichTextEditor/RichText'

import RestrictedPageAccess from './RestrictedPageAccess'

export default function RestrictedPageSuspended({
  suspensionAction,
}: {
  suspensionAction: SuspensionAction
}): JSX.Element {
  return (
    <RestrictedPageAccess
      alignCenter
      faIcon={faBan}
      iconColor="fg.error"
      title="Your account has been suspended."
      hideHomeButton
      hideLoginButton
      description={
        <Stack direction="column" spacing="32px">
          {shouldShowSuspensionNote(suspensionAction) ? (
            <RichText content={suspensionAction.note} />
          ) : (
            <>
              <Text>
                Unfortunately, your account has been suspended for violating our{' '}
                <ShwLink href={url.faq.getArticleUrl('community-guidelines')}>
                  community guidelines
                </ShwLink>
                . Specifically:{' '}
                <i>{SUSPENSION_ACTION_CONTEXT_TO_EXPLANATION[suspensionAction.context]}</i>
              </Text>
              <Text>
                If you&apos;d like to request an appeal or clarification on the nature of the
                violation, please feel free to reach out to our{' '}
                <ShwLink href={url.faq.getArticleUrl('how-do-i-contact-the-schoolhouse-team')}>
                  User Support
                </ShwLink>
                .
              </Text>
            </>
          )}
        </Stack>
      }
    />
  )
}
